module.exports = __webpack_public_path__ + "static/media/fo.8f009344.svg";